// Import modules
import Navigation from 'modules/_navigation'
import Print from 'modules/_print'
import VideoModal from './modules/_video-modal'
import PostSliders from './modules/_post-sliders'
import Faq from './modules/_faq'
import ArticlesArchive from './modules/_articles-archive'
import EmployeeSlider from 'modules/_employee-slider'

// Use modules
Navigation()
Print()
VideoModal()
PostSliders()
Faq()
ArticlesArchive()
EmployeeSlider()

